import getRemoteConfigValue from 'utils/firebase/remoteConfig';
const {KJUR} = require('jsrsasign');
const jwtDecode = require('jwt-decode');

const REQUIRED_TOKEN_FIELDS = [
  'aud',
  'sub',
  'iat',
  'exp',
  'iss',
  'permissions',
];
const IAT_TIME_DELTA_ALLOWANCE = 3600;

export const VerifyAndParseToken = token => {
  const integrationKeysRemoteConfigValue =
    getRemoteConfigValue('integration_keys');
  const INTEGRATION_KEYS = JSON.parse(
    integrationKeysRemoteConfigValue.asString(),
  );

  if (!token || typeof token === 'undefined' || token === 'undefined') {
    return {error: 'TokenEmptyError'};
  }
  // Decode only to select the configured issuer key. All claims below are
  // consumed only after the RS256 signature has been verified.
  let decodedToken;

  try {
    decodedToken = jwtDecode(token);
  } catch (error) {
    return {error: 'TokenMalformedError'};
  }

  const integration = decodedToken && decodedToken.iss;
  if (typeof integration !== 'string' || !(integration in INTEGRATION_KEYS)) {
    return {error: 'IntegrationInvalidError'};
  }

  try {
    const parsed = KJUR.jws.JWS.parse(token);
    if (
      !parsed.headerObj ||
      parsed.headerObj.alg !== 'RS256' ||
      !KJUR.jws.JWS.verify(token, INTEGRATION_KEYS[integration], ['RS256'])
    ) {
      return {error: 'TokenSignatureInvalidError'};
    }
  } catch (_error) {
    return {error: 'TokenSignatureInvalidError'};
  }

  for (const field of REQUIRED_TOKEN_FIELDS) {
    if (!Object.prototype.hasOwnProperty.call(decodedToken, field)) {
      return {error: 'TokenFieldsMissingError'};
    }
  }

  const {iat, exp, nbf, permissions, aud, sub, communicationServer} =
    decodedToken;
  const now = Math.floor(Date.now() / 1000);
  if (
    typeof aud !== 'string' ||
    typeof sub !== 'string' ||
    typeof iat !== 'number' ||
    typeof exp !== 'number' ||
    !Array.isArray(permissions) ||
    permissions.some(permission => typeof permission !== 'string')
  ) {
    return {error: 'TokenFieldsInvalidError'};
  }
  if (iat > now + IAT_TIME_DELTA_ALLOWANCE) {
    return {error: 'IATInvalidError'};
  }
  if (exp <= now) return {error: 'TokenExpiredError'};
  if (typeof nbf === 'number' && nbf > now + IAT_TIME_DELTA_ALLOWANCE) {
    return {error: 'TokenNotActiveError'};
  }

  if (
    typeof communicationServer !== 'undefined' &&
    typeof communicationServer !== 'string'
  ) {
    return {error: 'TokenFieldsInvalidError'};
  }

  return {
    integration: decodedToken.iss,
    expiration: decodedToken.exp,
    peerId: decodedToken.sub,
    roomId: decodedToken.aud,
    meetingName: decodedToken.meetingName,
    permissions: decodedToken.permissions,
    communicationServer: decodedToken.communicationServer,
  };
};
